/*
 * The one chart palette for every recharts chart in the portals. Values are
 * the Icewall theme tokens from index.css at the alpha the template's
 * report-*.js uses, so charts read as part of the same design system as the
 * tinted buttons and chips around them. Do not invent chart colours per page.
 */
export const CHART = {
  primary: 'rgba(30, 58, 138, 0.8)',
  success: 'rgba(22, 101, 52, 0.8)',
  danger: 'rgba(159, 18, 57, 0.8)',
  warning: 'rgba(133, 77, 14, 0.8)',
  pending: 'rgba(154, 52, 18, 0.8)',
  grid: 'rgba(51, 65, 85, 0.2)',
  tick: 'rgba(51, 65, 85, 0.5)',
  cursor: 'rgba(51, 65, 85, 0.06)',
  /* Donut / pie slices, in the order the dashboard already uses them. */
  donut: [
    { fill: 'rgba(154, 52, 18, 0.4)', stroke: 'rgba(154, 52, 18, 0.9)' }, // pending
    { fill: 'rgba(30, 58, 138, 0.4)', stroke: 'rgba(30, 58, 138, 0.9)' }, // primary
    { fill: 'rgba(133, 77, 14, 0.4)', stroke: 'rgba(133, 77, 14, 0.9)' }, // warning
    { fill: 'rgba(22, 101, 52, 0.4)', stroke: 'rgba(22, 101, 52, 0.9)' }, // success
    { fill: 'rgba(159, 18, 57, 0.4)', stroke: 'rgba(159, 18, 57, 0.9)' }, // danger
    { fill: 'rgba(51, 65, 85, 0.25)', stroke: 'rgba(51, 65, 85, 0.7)' }, // foreground
  ],
}

/* Prop bags for the shared recipe: dashed horizontal grid, no axis lines,
   muted small ticks, a soft cursor tint and rounded bar tops. Spread them
   onto the recharts children rather than wrapping the components. */
export const gridProps = { strokeDasharray: '2 2', stroke: CHART.grid, vertical: false } as const
export const xAxisProps = { tick: { fontSize: 11, fill: CHART.tick }, axisLine: false, tickLine: false, minTickGap: 8 } as const
export const yAxisProps = { tick: { fontSize: 12, fill: CHART.tick }, axisLine: false, tickLine: false, width: 36 } as const
export const tooltipProps = { cursor: { fill: CHART.cursor } } as const
export const BAR_RADIUS: [number, number, number, number] = [5, 5, 0, 0]

/** Axis tick for money and large counts: 1200 -> "1.2k". */
export function compactNumber(value: number): string {
  if (Math.abs(value) >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`
  if (Math.abs(value) >= 1000) return `${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 1)}k`
  return String(value)
}
